import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../shared/unleash-flags/use-unleash-flag';

/**
 * Global AI assistant (FAB + drawer, bridge, chart previews) is shown only when the
 * dedicated Unleash flag is on. Legacy CustomDash AI assistant remains controlled by
 * {@link FeatureFlag.AIPageBuilder} separately.
 */
export function useGlobalAIAssistantFeatureEnabled(): boolean {
  return useUnleashFlag(FeatureFlag.GlobalAIAssistant);
}
